var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frown",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2011",
    "data-name": "Ellipse 2011",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(2 2)",
    fill: "none",
    stroke: "#c74434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25287",
    "data-name": "Path 25287",
    d: "M16.8,16.2A5.939,5.939,0,0,0,12.4,14,5.939,5.939,0,0,0,8,16.2",
    transform: "translate(0.6 1.2)",
    fill: "none",
    stroke: "#c74434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3220",
    "data-name": "Line 3220",
    transform: "translate(10 10)",
    fill: "none",
    stroke: "#c74434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3221",
    "data-name": "Line 3221",
    transform: "translate(16 10)",
    fill: "none",
    stroke: "#c74434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrown);
export default __webpack_public_path__ + "static/media/frown.e0205244a136935054a5f76a05848d51.svg";
export { ForwardRef as ReactComponent };